<template>
  <div class="fiveview">
    <div class="selectview">
      <ul class="ullist">
        <li>
          <el-input placeholder="请输入用户openid" v-model="openid_input" clearable></el-input>
        </li>
        <li>
          <el-select v-model="type_value" clearable placeholder="请选择类型">
            <el-option
              v-for="item in typelist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </li>
        <li>
          <el-date-picker v-model="start_date" type="date" placeholder="选择开始日期"></el-date-picker>
        </li>
        <li>
          <el-date-picker v-model="end_date" type="date" placeholder="选择结束日期" :picker-options="pickerOptions"></el-date-picker>
        </li>
        <li>
          <el-button type="primary" class="querybutton" @click="searchClick()">查询</el-button>
        </li>
        <div style="clear:both;"></div>
      </ul>
    </div>

    <div class="tabelview">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{background:'#f3f3f3',color:'#333333'}"
        style="width:100%;"
      >
        <el-table-column align="left" prop="id" label="日志ID"></el-table-column>
        <el-table-column align="left" prop="return_code" label="通讯结果">
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.return_code == 'SUCCESS'">成功</span>
            <span class="fail" v-else-if="scope.row.return_code == 'FAIL'">失败</span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="result_code" label="业务结果">
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.result_code == 'SUCCESS'">成功</span>
            <span class="fail" v-else-if="scope.row.result_code == 'FAIL'">失败</span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="openid" label="微信用户openid" width="240"></el-table-column>
        <el-table-column align="left" prop="nickname" label="微信用户昵称" width="240"></el-table-column>
        <el-table-column align="left" prop="type" label="类型">
          <template slot-scope="scope">
            <span class="signing" v-if="scope.row.type == '1'">签约</span>
            <span class="rescission" v-else-if="scope.row.type == '2'">解约</span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="contract_termination_mode" label="解约方式" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.contract_termination_mode == '0'">未解约</span>
            <span v-else-if="scope.row.contract_termination_mode == '1'">有效期过自动解约</span>
            <span v-else-if="scope.row.contract_termination_mode == '2'">用户主动解约</span>
            <span v-else-if="scope.row.contract_termination_mode == '3'">商户API解约</span>
            <span v-else-if="scope.row.contract_termination_mode == '4'">商户平台解约</span>
            <span v-else-if="scope.row.contract_termination_mode == '5'">用户帐号注销</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="operate_time" label="操作时间" width="180"></el-table-column>
        <el-table-column align="left" prop="timestamp" label="入库时间" width="180"></el-table-column>
      </el-table>
    </div>

    <div class="cutpagesview">
      <el-pagination
        class="pageinclass"
        background
        :page-size="pagesize"
        :page-count="pagecount"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next,jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 10, //这个是总共有多少条数据
      pagesize: 20, //每页显示条目个数
      currentPage: 1, //当前页数
      pagecount: 10, //页码按钮的数量

      openid_input: "", //用户openid
      start_date: "", //开始日期
      end_date: "", //结束日期
      type_value: "", //类型1、签约，2、解约
      typelist: [
        {
          value: 1,
          label: "签约"
        },
        {
          value: 2,
          label: "解约"
        }
      ],

      tableData: [],
      pickerOptions: {
          disabledDate: (time) => {
              return time.getTime() < this.start_date || time.getTime() > Date.now();
          }
      },

    };
  },
  mounted() {
    
    var timestamp = new Date().getTime(); //毫秒
    // timestamp = timestamp - 7 * 24 * 3600 * 1000;
   if (this.$store.state.monthDay == 2) {
      var d = new Date(timestamp);
      let start_date =
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth()) +
        "-" +
        this.checkTime(d.getDate());

      this.start_date = start_date;
    } else {
      var d = new Date(timestamp);
      let start_date =
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth()+1) +
        "-" +
        this.checkTime(d.getDate());

      this.start_date = start_date;
    }
    var d1 = new Date();
    let end_date =
      d1.getFullYear() +
      "-" +
      this.checkTime(d1.getMonth()+1) +
      "-" +
      this.checkTime(d1.getDate());
    this.end_date = end_date;
    this.querybtnClick();
  },
  methods: {
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      var value = String(val)
      this.querybtnClick(value);
    },
    /**
     * 筛选签约日志
     */
    querybtnClick(page) {
      this.tableData = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getWechatContractLogs"
      };
      if(page != '' && page != null){
        params.page = page;
      }
      if (this.openid_input != "") {
        params.openid = this.openid_input;
      }
      if (this.type_value != "") {
        params.type = this.type_value;
      }
      if (this.start_date != "" && this.start_date != null) {
        var d = new Date(this.start_date);
        // console.log("开始时间--：",d)
        let start_date =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate());
          this.start_date = start_date;
        params.start_date = start_date;

        //最后显示yyyy-MM-dd
      }
      if (this.end_date != "" && this.end_date != null) {
        var d1 = new Date(this.end_date);
        // console.log("结束时间--：",d1)
        let end_date =
          d1.getFullYear() +
          "-" +
          this.checkTime(d1.getMonth() + 1) +
          "-" +
          this.checkTime(d1.getDate());
        //最后显示yyyy-MM-dd
        // console.log("结束时间++++--：",end_date)
        this.end_date = end_date;
        params.end_date = end_date;
      }

      // console.log("签约日志筛选传参--：", params);
      if(this.start_date > this.end_date){
        this.$message.warning("结束日期不能小于开始日期");
      }else{
        this.$api({
        method: "post",
        url: "/api.php/AlarmManage/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          // console.log("签约su--：", su);
          if (su.data.code == 1) {
            let datalist = su.data.list;
            // this.total = datalist.length;
            // this.pagecount = parseInt(datalist.length / 8 + 1);
            this.tableData = datalist;
            if(su.data.count == '' || su.data.count == null){
              
            }else{
              
              this.total = su.data.count;
              this.pagecount = su.data.count / 20;
            }
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
      }
      this.$api({
        method: "post",
        url: "/api.php/AlarmManage/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          // console.log("签约su--：", su);
          if (su.data.code == 1) {
            let datalist = su.data.list;
            // this.total = datalist.length;
            // this.pagecount = parseInt(datalist.length / 8 + 1);
            this.tableData = datalist;
            if(su.data.count == '' || su.data.count == null){
              
            }else{
              
              this.total = su.data.count;
              this.currentPage = 1;
              // this.pagecount = su.data.count / 20;
              if(su.data.count % 20 == 0){
                
                this.pagecount = parseInt(su.data.count / 20);
                
              }else{
                this.pagecount = parseInt(su.data.count / 20 + 1);
                
              }
            }
          }else if (su.data.code == 300) {
            //登陆过期
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 0) {
            this.total = 0;
            this.pagecount = 1; 
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.total = 0;
            this.pagecount = 1; 
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    searchClick(){
      this.total = 10;
      this.pagesize = 20;
      this.currentPage = 1;
      this.pagecount = 10;
      this.querybtnClick();
    },
  }
};
</script>
<style scoped lang="scss">
.fiveview {
  padding: 1%;
  background-color: white;
  .el-button--primary:focus, .el-button--primary:hover{
    background: #0071bd;
    border-color: #0071bd;
    color: #fff
  }
}

.ullist {
  list-style-type: none;
  padding: 0;
  li {
    float: left;
    // display: inline-block;
    margin: 5px 5px 5px 0px;
  }
}
.tabelview {
  margin-top: 15px;
  margin-bottom: 15px;
  .success {
    color:#009a5b;
  }
  .fail {
    color:#e60000;
  }
  .signing {
    color:#009a5b;
  }
  .rescission {
    color:#e60000;
  }
}
.el-table__row.hover-row {
  .success {
    color: #ffffff;
  }
  .fail {
    color: #ffffff;
  }
  .signing {
    color: #ffffff;
  }
  .rescission {
    color: #ffffff;
  }
}

.querybutton {
  width: 80px;
  margin-left: 15px;
  // height: 35px;
  text-align: center;
  display: inline-block;
  background-color: #0071bd;
  color: white;
  border: none;
}
.fiveview {
  .querybutton:active {
    background-color: #409EFF;
  }
}
.cutpagesview {
  margin: 20px 0;
  height: 30px;
}
.pageinclass {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/operationManagement/signedLog.vue